module.exports = __webpack_public_path__ + "img/3.b11ed791.svg";